import { Component, OnInit, OnDestroy, Provider } from "@angular/core";
import { SelectItem } from "primeng/api";
import { DoctorBreadcrumbService } from "../../shared/breadcrumb.service";
import { Doctor, fetchAllData, ProfileCardData } from "../../../../models/Doctor";
import { DoctorProfileForDoctorDash } from "../../../../models/Doctorprofile";
import { DoctorprofileService } from "../../../../services/doctorprofile.service";
import { PromiseResult } from "../../../../models/PromiseResult";
import { UtilitiesService } from "src/app/utilities/utilities.service";
import { Router } from "@angular/router";
import { USER_TYPES, PROFILES_TYPE } from "src/app/constant/constant";
import { OthermedicalregistrationService } from "src/app/services/othermedicalregistration.service";
import { Title } from "@angular/platform-browser";
import { TraceClassDecorator } from "@sentry/angular";
import { ProviderStateService } from "src/app/services/provider-state.service";


@TraceClassDecorator()
@Component({
    selector: "app-doctordata",
    templateUrl: "./doctordata.component.html",
    styleUrls: ["./doctordata.component.css"
        , '../../../../../assets/css/custom-egd.css'
    ],
})
export class DoctordataComponent implements OnInit, OnDestroy {
    readonly userTypes = USER_TYPES;

    base_url: string = "";

    sortOptions: SelectItem[];
    sortOrder: number;
    sortField: string;
    // doctors: Doctor[] = [];
    doctorProfile: DoctorProfileForDoctorDash;

    sortKey: any;

    doctorss: Doctor[];

    DoctorProfileDialogVisible: boolean = false;
    OtherMedicalProfileDialogVisible: boolean = false;
    DoctorReferralVisible: boolean = false;
    ReferralConfirmVisible: boolean = false;
    referralLinkDialog: boolean = false;
    user_guid: string;
    response: PromiseResult;
    posting: boolean;
    public current_doctor_userid = "";
    provider_id: string = "";
    // link: string = environment.portalPageUrl + 'user/doctor/registration';
    link: string ;
    is_primary_provider: boolean = false;
    copied_response: boolean;
    profiles_type_data: SelectItem[] = PROFILES_TYPE;
    profiles_type: number = 0;
    profile_card_data: ProfileCardData[] = [];
    slug: string = "";
    constructor(
        private readonly router: Router,
        private readonly doctorProfileService: DoctorprofileService,
        private readonly othermedicalregistrationService: OthermedicalregistrationService,
        private readonly breadcrumbService: DoctorBreadcrumbService,
        public utilitiesService: UtilitiesService,
        public titleService: Title,
        private readonly providerstateService: ProviderStateService
    ) {
        this.base_url = this.utilitiesService.getBaseUserURL(this.router.url, 2)
        

        this.sortOptions = [
            { label: "Occupation", value: "occupation" },
            { label: "Name", value: "name" },
        ];
        this.posting = false;
        this.copied_response = false;
    }

    async ngOnInit() {
        this.titleService.setTitle("Dashboard - Profile");
        this.slug = this.providerstateService.getProviderSlug();
        this.is_primary_provider = this.providerstateService.getIsPrimaryProvider();
        this.link = this.utilitiesService.getBaseUrl("PORTAL_BASE_URL") + this.slug + 'user/doctor/registration';
        this.provider_id = this.providerstateService.getProviderId();
        this.breadcrumbService.setItems([
            { label: "Dashboard", routerLink: [`/${this.slug}/doctor`] },
            { label: "Profiles" },
        ]);
        this.current_doctor_userid = sessionStorage.getItem('userid');
        this.response = {
            success: null,
            error: null,
            data: null
        }
        await this.onProfessionalChange();





    }

    private async ResetResultModels(): Promise<void> {
        this.response = {
            success: null,
            error: null,
            data: null
        }
    }


    close(closeDialog) {
        this.DoctorProfileDialogVisible = closeDialog;
        this.OtherMedicalProfileDialogVisible = closeDialog;
    }

    private async getDoctors(): Promise<void> {
        await this.ResetResultModels();
        this.posting = true;
        let data : fetchAllData = new fetchAllData();
        data.provider_id = this.provider_id;
        let temp: ProfileCardData[] = [];
        await this.doctorProfileService.GetAllDoctorProfiles(data).toPromise().then((result) => {
            if (result.success) {
                // this.doctors = result.data;
                result.data.forEach(async element => {
                    temp.push({
                        avatar_url: element.egd_users.avatar_url,
                        name: await this.utilitiesService.titlecase(element.salutation) + " " + element.egd_users.first_name + ' ' + element.egd_users.last_name,
                        occupation: element.speciality.specialty_name,
                        country: element.egd_users.country.country_name,
                        user_guid: element.egd_users.user_guid,
                    })
                });
            }

        })

        this.profile_card_data = temp;
        this.posting = false;

        // for (let i = 0; i < this.doctors.length; i++) {
        //     this.doctors[i].salutation = this.utilitiesService.titlecase(this.doctors[i].salutation)
        // }

    }

    private async getOtherMedicalProfesional(): Promise<void> {
        await this.ResetResultModels();
        this.posting = true;
        let temp: ProfileCardData[] = [];
        await this.othermedicalregistrationService.getAllOtherProfessionsList().toPromise().then((result) => {
            if (result.success) {
                // this.doctors = result.data;
                result.data.data.forEach(async element => {
                    temp.push({
                        avatar_url: element.avatar_url,
                        name: element.first_name + " " + element.last_name,
                        occupation: " ",
                        country: element.country.country_name,
                        user_guid: element.user_guid,
                    })
                });
            }
        });
        this.profile_card_data = temp;
        this.posting = false;
    }



    onSortChange(event: { value: any }) {
        let value = event.value;

        if (value.indexOf("!") === 0) {
            this.sortOrder = -1;
            this.sortField = value.substring(1, value.length);
        } else {
            this.sortOrder = 1;
            this.sortField = value;
        }
    }

    async onProfessionalChange() {
        if (this.profiles_type == 0) {
            await this.getDoctors()
        }
        else if (this.profiles_type == 1) {
            await this.getOtherMedicalProfesional()
        }

    }
    openDialog() {
        this.DoctorReferralVisible = true;
    }

    async GetProfileData(user_guid) {
        if (this.profiles_type == 0) {
            await this.GetDoctorProfile(user_guid);
        }
        else if (this.profiles_type == 1) {
            await this.GetOtherMedicalProfile(user_guid);
        }
    }

    async GetDoctorProfile(user_guid: string): Promise<void> {
        this.DoctorProfileDialogVisible = true
        this.user_guid = user_guid;
    }

    async CloseDoctorProfileDialog(): Promise<void> {
        this.DoctorProfileDialogVisible = false;
        this.doctorProfile = null;
        this.user_guid = null;

    }

    async GetOtherMedicalProfile(user_guid: string): Promise<void> {
        this.OtherMedicalProfileDialogVisible = true
        this.user_guid = user_guid;
    }

    async CloseOtherMedicalProfileDialog(): Promise<void> {
        this.OtherMedicalProfileDialogVisible = false;
        this.doctorProfile = null;
        this.user_guid = null;

    }


    async ngOnDestroy() {
        this.link = null;
    }

    async CopyLink(): Promise<void> {
        if (this.link != null) {
            await navigator.clipboard.writeText(this.link).then(result => {

                this.copied_response = true;
            }).catch(error => {

            })
        }
    }


}
